export class FormulaireContact {
    sujet: string;
    nature: string;
    theme: string;
    priorite: string;
    origine: string;
    message: string;
    file: File;
    constructor() {
    }
}
